<div class="main-visit-container">
  <div class="main-visit-mobile-logo">
    <app-icon [icon]="Icons.logo"/>
  </div>
  <div class="main-visit-background" [style.background-image]="getBackground('bg')" [style]="getBackground('filter')"></div>
  <div class="main-visit-content">
    <h1 class="text-white text-uppercase fw-normal large-text main-visit-content-el figma-text">
      <app-texts
        [texts]="[
          {text: ['Откройте ', 'Visit ']},
          {text: [countryService.getRandom().titleAccusativeRu ?? countryService.getRandom().titleRu, countryService.getRandom().titleEn], fontFamily: 'pds', fontStyle: 'italic'},

        ]"
      />
    </h1>
    <h1 class="text-white text-uppercase fw-normal large-text main-visit-content-el figma-text">
      <app-texts
        [texts]="[
          {text: ['с First Class', 'with First Class']},
        ]"
      />
    </h1>
<!--    <div class="main-visit-content-portal-container">-->
<!--      <app-portal-country/>-->
<!--    </div>-->
    <app-button class="mt-3">
      <h4 class="px-5 figma-button" (click)="openCountry()">
        <app-texts
          [texts]="[
            {text: ['Подробнее ', 'Discover'], color: 'white', fontFamily: 'manrope'}
          ]"
        />
      </h4>
    </app-button>
  </div>
</div>

